module.exports = __webpack_public_path__ + "static/media/card.e91bd4d3.png";